export interface RussianCountForms {
  few: string;
  many: string;
  one: string;
}

export function formatRussianCount(count: number, forms: RussianCountForms): string {
  const absoluteCount = Math.abs(count);
  const modulo100 = absoluteCount % 100;
  const modulo10 = absoluteCount % 10;

  if (modulo100 >= 11 && modulo100 <= 14) {
    return `${count} ${forms.many}`;
  }

  if (modulo10 === 1) {
    return `${count} ${forms.one}`;
  }

  if (modulo10 >= 2 && modulo10 <= 4) {
    return `${count} ${forms.few}`;
  }

  return `${count} ${forms.many}`;
}
